import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PasswordResetRequest {
  email: string;
}

export interface PasswordResetValidate {
  token: string;
  newPassword: string;
}

export interface PasswordResetTokenStatus {
  isValid: boolean;
  isExpired: boolean;
  isUsed: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class PasswordResetService {
  private apiUrl = `${environment.apiUrl}/passwordreset`;

  constructor(private http: HttpClient) { }

  /**
   * Solicita reset de senha enviando email
   */
  requestPasswordReset(email: string): Observable<any> {
    const body: PasswordResetRequest = { email };
    return this.http.post(`${this.apiUrl}/request`, body, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /**
   * Valida o token de reset de senha
   */
  validateToken(token: string): Observable<PasswordResetTokenStatus> {
    return this.http.get<PasswordResetTokenStatus>(`${this.apiUrl}/validate-token`, {
      params: { token }
    });
  }

  /**
   * Valida o token e redefine a senha
   */
  resetPassword(token: string, newPassword: string): Observable<any> {
    const body: PasswordResetValidate = { token, newPassword };
    return this.http.post(`${this.apiUrl}/validate`, body, {
      headers: { 'Content-Type': 'application/json' }
    });
  }
}
